import API from './config'

export const TemporaryTransferAPI = {

    async createTemporaryTransfer(temporaryTransfer) {
        let config = { headers: { 'x-access-token': localStorage.getItem('token') } }
        try {
            const response = await API.post('/temporary_transfers/create', temporaryTransfer, config)
            return { success: true, body: response.data };
        } catch (error) {
            console.log("ERROR: ", error.response)
            return { success: false, body: error.response.data };
        }
    },

    async listTemporaryTransfers(originUserId) {
        let config = { headers: { 'x-access-token': localStorage.getItem('token') } }
        try {
            const response = await API.get('/temporary_transfers/list' + (originUserId ? '?origin_user_id=' + originUserId : ''), config)
            return { success: true, body: response.data };
        } catch (error) {
            return { success: false, body: error.response.data };
        }
    },

    async listScheduledByClient() {
        let config = { headers: { 'x-access-token': localStorage.getItem('token') } }
        try {
            const response = await API.get('/temporary_transfers/scheduledByClient', config)
            return { success: true, body: response.data };
        } catch (error) {
            return { success: false, body: error.response.data };
        }
    },

    async getTemporaryTransferClients(id) {
        let config = { headers: { 'x-access-token': localStorage.getItem('token') } }
        try {
            const response = await API.get('/temporary_transfers/clients?id=' + id, config)
            return { success: true, body: response.data };
        } catch (error) {
            return { success: false, body: error.response.data };
        }
    },

    async deleteTemporaryTransfer(id) {
        let config = { headers: { 'x-access-token': localStorage.getItem('token') } }
        try {
            const response = await API.delete('/temporary_transfers/' + id, config)
            return { success: true, body: response.data };
        } catch (error) {
            console.log("ERROR: ", error.response)
            return { success: false, body: error.response.data };
        }
    },

    async updateStatus(id, status) {
        let config = { headers: { 'x-access-token': localStorage.getItem('token') } }
        try {
            const response = await API.put('/temporary_transfers/updateStatus', { id, status }, config)
            return { success: true, body: response.data };
        } catch (error) {
            console.log("ERROR: ", error.response)
            return { success: false, body: error.response.data };
        }
    },
}
